import {
    IconCalendar4x3,
    IconExternalLink,
    IconHandsPraiseShieldCheck,
    IconLogoDarwinexZero,
    IconWorld,
    Modal
} from '@darwinex/components-library';
import React from "react";
import styles from "src/components/auth/Auth.module.scss"
import {useTranslationService} from "src/services/TranslationService";
import DxZeroImage from 'src/assets/images/dx-zero-mobile-platform.png';

export const NotAvailableInYourCountryModal = ({onClose}) => {
    const {t} = useTranslationService();
    const textContainerClasses='dx-mt-md-4';
    const textTitleClasses='font-open-sans--bold text-md-center dx-font-size-sm dx-mb-3';
    const textDescClasses='font-open-sans--semi-bold dx-font-size-xs';

    return <Modal size={'lg'} title={<IconLogoDarwinexZero/>} onModalClose={onClose} type={'plain'}>
        <div className={'d-flex justify-content-between dx-gx-10'}>
            <div>
                <p className={"dx-font-size-lg"}>{t("new-login.modal-not-available.title")}</p>
                <p className={"dx-font-size-h4"}>{t("new-login.modal-not-available.try-dxzero")}</p>
                <p className={"dx-font-size-sm"}>{t("new-login.modal-not-available.costs")}</p>
                <div className={'d-flex dx-g-3 flex-column flex-md-row'}>
                    <div className={styles.dx_zero__info_container}>
                        <div className={styles.dx_zero__icon}><IconHandsPraiseShieldCheck/></div>
                        <div className={textContainerClasses}>
                            <div className={textTitleClasses}>{t("new-login.modal-not-available.info.risk-free.title")}</div>
                            <div className={textDescClasses}>{t("new-login.modal-not-available.info.risk-free.text")}</div>
                        </div>
                    </div>
                    <div className={styles.dx_zero__info_container}>
                        <div className={styles.dx_zero__icon}><IconCalendar4x3/></div>
                        <div className={textContainerClasses}>
                            <div className={textTitleClasses}>{t("new-login.modal-not-available.info.monthly-subscription.title")}</div>
                            <div className={textDescClasses}>{t("new-login.modal-not-available.info.monthly-subscription.text")}</div>
                        </div>
                    </div>
                    <div className={styles.dx_zero__info_container}>
                        <div className={styles.dx_zero__icon}><IconWorld/></div>
                        <div className={textContainerClasses}>
                            <div className={textTitleClasses}>{t("new-login.modal-not-available.info.worldwide-service.title")}</div>
                            <div className={textDescClasses}>{t("new-login.modal-not-available.info.worldwide-service.text")}</div>
                        </div>
                    </div>
                </div>
            </div>
            <img className={'d-none d-md-block'} src={DxZeroImage} alt={'Darwinex Zero'}
                 width={200} height={306}/>
        </div>
        <div className={'d-flex justify-content-center dx-mt-7'}>
            <a href={'https://www.darwinexzero.com?utm_source=darwinex&utm_medium=link&utm_campaign=to_zero&utm_content=register'} className={styles.dx_zero__button}>
                {t("new-login.modal-not-available.cta")}<IconExternalLink className={'dx-ml-3'} height={24}/>
            </a>
        </div>
    </Modal>
}
